import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/',
    name: 'Root',
    component: () => import('@/views/ConnectorMarket.vue'),
    meta: {
      title: '连接器市场'
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/Dashboard.vue'),
    meta: {
      title: '控制台'
    }
  },
  {
    path: '/platform-management',
    name: 'PlatformManagement',
    component: () => import('@/views/PlatformManagement.vue'),
    meta: {
      title: '平台管理'
    }
  },
  {
    path: '/platform-api/:platCode',
    name: 'PlatformApiManagement',
    component: () => import('@/views/ApiManagement.vue'),
    meta: {
      title: '平台API列表'
    },
    props: true
  },
  {
    path: '/datasource-api/:platCode',
    name: 'DatasourceApiManagement',
    component: () => import('@/views/ApiManagement.vue'),
    meta: {
      title: '数据账户API列表'
    },
    props: true
  },
  {
    path: '/management-api/:platCode',
    name: 'ApiManagement',
    component: () => import('@/views/ApiManagement.vue'),
    meta: {
      title: 'API列表'
    },
    props: true
  },
  {
    path: '/interface-config/:platCode',
    name: 'ApiConfig',
    component: () => import('@/views/ApiConfigRoute.vue'),
    meta: {
      title: '接口配置'
    },
    props: true
  },
  {
    path: '/platform-detail/:platCode',
    name: 'PlatformDetail',
    component: () => import('@/views/PlatformDetail.vue'),
    meta: {
      title: '平台详情'
    }
  },
  {
    path: '/database-management',
    name: 'DatabaseManagement',
    component: () => import('@/views/DatabaseManagement.vue'),
    meta: {
      title: '数据库管理'
    }
  },
  {
    path: '/database-query/:databaseId',
    name: 'DatabaseQuery',
    component: () => import('@/views/DatabaseQuery.vue'),
    meta: {
      title: '数据库查询'
    }
  },
  {
    path: '/bi-management',
    name: 'BiManagement',
    component: () => import('@/views/BiManagement.vue'),
    meta: {
      title: 'BI环境'
    }
  },
  {
    path: '/task-history',
    name: 'TaskHistory',
    component: () => import('@/views/TaskHistory.vue'),
    meta: {
      title: '任务管理'
    }
  },
  {
    path: '/datasource-management',
    name: 'DatasourceManagement',
    component: () => import('@/views/DatasourceManagement.vue'),
    meta: {
      title: '数据账户管理'
    }
  },
  {
    path: '/customer-management',
    name: 'CustomerManagement',
    component: () => import('@/views/CustomerManagement.vue'),
    meta: {
      title: '客户信息管理'
    }
  },
  {
    path: '/customer-detail',
    name: 'CurrentCustomerDetail',
    component: () => import('@/views/CustomerDetail.vue'),
    meta: {
      title: '客户详情'
    }
  },
  {
    path: '/customer-detail/:customerCode',
    name: 'CustomerDetail',
    component: () => import('@/views/CustomerDetail.vue'),
    meta: {
      title: '客户详情'
    }
  },
  {
    path: '/data-connection-config',
    name: 'DataConnectionConfig',
    component: () => import('@/views/DataConnectionConfig.vue'),
    meta: {
      title: '数据连接配置'
    }
  },
  {
    path: '/auth-callback',
    name: 'AuthCallback',
    component: () => import('@/views/AuthCallback.vue'),
    meta: {
      title: '授权回调'
    }
  },
  {
    path: '/auth-callback/:platCode',
    name: 'AuthCallbackWithPlatform',
    component: () => import('@/views/AuthCallback.vue'),
    meta: {
      title: '授权回调'
    }
  },
  {
    path: '/callback/:platCode',
    name: 'CallbackWithPlatform',
    component: () => import('@/views/AuthCallback.vue'),
    meta: {
      title: '授权回调'
    }
  },
  // 系统监控功能已隐藏
  // {
  //   path: '/monitoring',
  //   name: 'Monitoring',
  //   component: () => import('@/views/Monitoring.vue'),
  //   meta: {
  //     title: '系统监控'
  //   }
  // },
  {
    path: '/alert-management',
    name: 'AlertManagement',
    component: () => import('@/views/AlertManagement.vue'),
    meta: {
      title: '告警管理'
    }
  },
  {
    path: '/audit-log',
    name: 'AuditLog',
    component: () => import('@/views/AuditLog.vue'),
    meta: {
      title: '审计日志'
    }
  },
  {
    path: '/platform-monitoring',
    name: 'PlatformMonitoring',
    component: () => import('@/views/PlatformMonitoring.vue'),
    meta: {
      title: '平台监控'
    }
  },
  {
    path: '/grafana-dashboard',
    name: 'GrafanaDashboard',
    component: () => import('@/views/GrafanaDashboard.vue'),
    meta: {
      title: '服务监控',
      guandataOnly: true
    }
  },
  {
    path: '/connector-market',
    name: 'ConnectorMarket',
    component: () => import('@/views/ConnectorMarket.vue'),
    meta: {
      title: '连接器市场'
    }
  },
  {
    path: '/connector-market/:platCode/apis',
    name: 'ConnectorMarketApiList',
    component: () => import('@/views/ConnectorMarketApiList.vue'),
    meta: {
      title: '连接器 API 列表'
    }
  },
  {
    path: '/connector-market/:platCode',
    name: 'ConnectorMarketDetail',
    component: () => import('@/views/ConnectorMarketDetail.vue'),
    meta: {
      title: '连接器详情'
    }
  },
  {
    path: '/no-permission',
    name: 'NoPermission',
    component: () => import('@/views/NoPermission.vue'),
    meta: {
      title: '无权限'
    }
  },

  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue'),
    meta: {
      title: '页面未找到'
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

const DEV_AUTH_FLAG = 'apiConnector_devAuth'
const DEV_AUTH_TOKEN = 'dev-auth-token'

router.beforeEach(async (to, _from, next) => {
  // 设置页面标题
  document.title = to.meta.title ? `${to.meta.title} - 数据连接器` : '数据连接器'

  const isExplicitDevAuthRequest = (import.meta as any).env.DEV && to.query.devAuth === '1'
  const isDevAuthRequest = isExplicitDevAuthRequest

  if (isDevAuthRequest) {
    localStorage.setItem(DEV_AUTH_FLAG, '1')
    localStorage.setItem('token', localStorage.getItem('token') || DEV_AUTH_TOKEN)
    if (typeof to.query.customerCode === 'string') {
      localStorage.setItem('apiConnector_devCustomerCode', to.query.customerCode)
    }
  } else if ((import.meta as any).env.DEV && localStorage.getItem(DEV_AUTH_FLAG) === '1') {
    localStorage.removeItem(DEV_AUTH_FLAG)
    localStorage.removeItem('apiConnector_devCustomerCode')
    if (localStorage.getItem('token') === DEV_AUTH_TOKEN) {
      localStorage.removeItem('token')
    }
  }
  
  // 无需登录即可访问的白名单路由
  // 说明：
  // - 登录页始终允许访问
  // - 连接器市场相关（含 /connector-market/...）全部开放
  // - 从连接器市场进入的 API 列表页（ApiManagement?fromMarket=true）也开放
  // - 授权回调页面（auth-callback 和 callback）允许访问
  const isPublicRoute =
    to.path === '/login' ||
    to.path === '/' ||
    to.path === '/connector-market' ||
    to.path === '/no-permission' ||
    to.path.startsWith('/connector-market/') ||
    to.path === '/auth-callback' ||
    to.path.startsWith('/auth-callback/') ||
    to.path.startsWith('/callback/') ||
    (to.name === 'ApiManagement' && to.query.fromMarket === 'true')
  
  // 检查是否有token
  const token = isDevAuthRequest ? DEV_AUTH_TOKEN : localStorage.getItem('token')
  
  // 如果访问根路径或其他路由
  if (!token) {
    // 未登录访问受保护路由，跳转到登录并记录重定向地址
    if (!isPublicRoute) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
      return
    }
    next()
    return
  }
  
  // 已登录访问登录页
  if (to.path === '/login') {
    try {
      const { useUserStore } = await import('@/stores/user')
      const userStore = useUserStore()
      if (!userStore.getUser) {
        await userStore.fetchCurrentUser()
      }
    } catch (error) {
      console.error('获取用户信息失败:', error)
    }

    const redirectTarget = typeof to.query.redirect === 'string' && to.query.redirect
      ? to.query.redirect
      : '/platform-monitoring'

    next(redirectTarget)
    return
  }

  // 如果路由是连接器市场，允许访问（无论是刷新还是直接访问）
  if (to.path === '/' || to.path === '/connector-market' || to.path.startsWith('/connector-market/')) {
    next()
    return
  }

  try {
    const { useUserStore } = await import('@/stores/user')
    const userStore = useUserStore()
    if (!userStore.getUser) {
      await userStore.fetchCurrentUser()
    }
    const currentCustomerCode = userStore.getUser?.customerCode
    const currentUsername = userStore.getUser?.username
    const isGuandataUser = currentCustomerCode === 'GUANDATA'
    const isCustomerAdminUser = currentUsername === 'admin'

    if (currentCustomerCode && !isGuandataUser && to.path === '/customer-management') {
      if (!isCustomerAdminUser) {
        next('/no-permission')
        return
      }

      next({
        name: 'CurrentCustomerDetail'
      })
      return
    }

    if (currentCustomerCode && !isGuandataUser
      && (to.name === 'CurrentCustomerDetail' || to.name === 'CustomerDetail')) {
      if (!isCustomerAdminUser) {
        next('/no-permission')
        return
      }

      if (to.name === 'CustomerDetail') {
        next({
          name: 'CurrentCustomerDetail'
        })
        return
      }
    }
  } catch (error) {
    console.error('获取用户信息失败:', error)
    next('/no-permission')
    return
  }

  if (to.meta.guandataOnly) {
    try {
      const { useUserStore } = await import('@/stores/user')
      const userStore = useUserStore()
      if (!userStore.getUser) {
        await userStore.fetchCurrentUser()
      }
      if (userStore.getUser?.customerCode !== 'GUANDATA') {
        next('/no-permission')
        return
      }
    } catch (error) {
      console.error('获取用户信息失败:', error)
      next('/no-permission')
      return
    }
  }
  
  next()
})

export default router 
